import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d5a307a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "course-catalogue"
};
const _hoisted_2 = {
  class: "catalogue-label-row"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "catalogue-label-title"
};
const _hoisted_5 = {
  class: "catalogue-label-name"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "catalogue-try"
}, "体验", -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "catalogue-label-info-content"
};
const _hoisted_10 = {
  class: "catalogue-right"
};
const _hoisted_11 = {
  class: "catalogue-right-progress"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 2
};
import { reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import router from '@/router';
import { ICON_MAP } from '@/utils/constance';
import Catalogue from '@/components/Catalogue';
import ExecirsePop from './ExecirsePop';
import { postUserOnLine } from '@/api/app';
import { handleToLogin } from '@/utils/router';
export default {
  __name: 'Catalogue',
  props: {
    courseInfo: {
      type: Object,
      default: () => ({})
    },
    questionList: {
      type: Array,
      default: () => []
    },
    dialogExecrise: {
      type: Boolean,
      default: false
    }
  },
  emits: ['preExecirse', 'closeExeDialog'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const state = reactive({
      dialogExecrise: props.dialogExecrise
    });
    watch(() => props.dialogExecrise, val => {
      state.dialogExecrise = val;
    });
    const computedProgress = progress => Math.round(progress * 100);
    const computedShowBth = (isExperience, resourceType) => (props.courseInfo.free === '0' || props.courseInfo.learnStatus || isExperience === '1') && resourceType !== 'PAPER';
    const computedExecirseBtn = (isExperience, resourceType) => (props.courseInfo.free === '0' || props.courseInfo.learnStatus || isExperience === '1') && resourceType === 'PAPER';

    // 是否登录
    const isOnLine = () => {
      return postUserOnLine();
    };
    const handleToPreview = async (kid, resourceId, preview = true) => {
      var _props$courseInfo;
      if (!preview) {
        const res = await isOnLine();
        if (!res.success) {
          handleLoginBack();
        } else {
          if (!props.courseInfo.learnStatus) {
            return false;
          }
        }
      }
      if (!resourceId) {
        ElMessage.info('该小节没有资源，请稍后重试...');
        return;
      }
      // const url = `/preview?cId=${props.courseInfo?.id}&kId=${kid}${preview ? '&preview=1' : ''}`
      // window.open(url)
      router.push(`/preview?cId=${(_props$courseInfo = props.courseInfo) === null || _props$courseInfo === void 0 ? void 0 : _props$courseInfo.id}&kId=${kid}${preview ? '&preview=1' : ''}`);
    };
    const handleToPreviewExecirse = async resourceId => {
      const res = await isOnLine();
      if (!res.success) {
        handleLoginBack();
      } else {
        emit('preExecirse', resourceId);
      }
    };
    const handleLoginBack = async () => {
      const loginRes = await handleToLogin();
      if (loginRes.success) {
        var _props$courseInfo2;
        router.push({
          path: '/course/detail',
          query: {
            id: (_props$courseInfo2 = props.courseInfo) === null || _props$courseInfo2 === void 0 ? void 0 : _props$courseInfo2.id,
            tab: 'catalogue'
          }
        });
      }
    };
    const handleCloseDialog = () => {
      emit('closeExeDialog');
    };
    return (_ctx, _cache) => {
      var _props$courseInfo3, _props$courseInfo3$co, _props$courseInfo4;
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_empty = _resolveComponent("el-empty");
      return ((_props$courseInfo3 = __props.courseInfo) === null || _props$courseInfo3 === void 0 ? void 0 : (_props$courseInfo3$co = _props$courseInfo3.contentInfo) === null || _props$courseInfo3$co === void 0 ? void 0 : _props$courseInfo3$co.length) !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Catalogue), {
        list: (_props$courseInfo4 = __props.courseInfo) === null || _props$courseInfo4 === void 0 ? void 0 : _props$courseInfo4.contentInfo
      }, {
        content: _withCtx(({
          id,
          duration,
          progress,
          finish,
          isExperience,
          index,
          resourceType,
          name,
          resourceId
        }) => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: "catalogue-label-info",
          onClick: $event => handleToPreview(id, resourceId, false)
        }, [_createElementVNode("span", _hoisted_4, "第" + _toDisplayString(index + 1) + "节", 1), _createVNode(_component_el_image, {
          class: "catalogue-label-image",
          src: _unref(ICON_MAP)[`${resourceType || 'WEIKE' || 'PAPER'}_GRAY`]
        }, null, 8, ["src"]), _createElementVNode("span", _hoisted_5, _toDisplayString(name), 1), !__props.courseInfo.learnStatus && isExperience === '1' ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true)], 8, _hoisted_3), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, [finish === 'N' && computedProgress(progress) < 1 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "学习不足1%")) : _createCommentVNode("", true), finish === 'N' && computedProgress(progress) >= 1 && computedProgress(progress) < 100 ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 已学习" + _toDisplayString(computedProgress(progress)) + "% ", 1)) : _createCommentVNode("", true), finish === 'Y' || computedProgress(progress) >= 100 ? (_openBlock(), _createElementBlock("span", _hoisted_14, "已学完")) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("span", {
          class: _normalizeClass(["color-999", {
            'catalogue-right-duration': computedShowBth(isExperience)
          }])
        }, " 时长：" + _toDisplayString(duration), 3), [[_vShow, duration]]), computedShowBth(isExperience, resourceType) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          size: "small",
          type: "primary",
          class: "catalogue-right-button",
          onClick: $event => handleToPreview(id, resourceId)
        }, {
          default: _withCtx(() => [_createTextVNode(" 预览 ")]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), computedExecirseBtn(isExperience, resourceType) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          size: "small",
          type: "primary",
          class: "catalogue-right-button",
          onClick: $event => handleToPreviewExecirse(resourceId)
        }, {
          default: _withCtx(() => [_createTextVNode(" 预览 ")]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)])])])]),
        _: 1
      }, 8, ["list"]), _createVNode(_unref(ExecirsePop), {
        dialogExecrise: state.dialogExecrise,
        questionList: props.questionList,
        onCloseExeDialog: handleCloseDialog
      }, null, 8, ["dialogExecrise", "questionList"])])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "暂无数据"
      }));
    };
  }
};